export default __webpack_public_path__ + "static/media/saladitas.bb1578f8.png";